import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { ContextMenuItemView, UnitContextMenuClickParams } from '@mark43/cad-api';
import { useBroadcast } from '../common/broadcast-channel/use-broadcast';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';
import { useViewLocationOnMap } from '../location/hooks/use-view-location-on-map';
import { EsriMapEntityTypeEnum } from '../esri/types';

export function ViewOnMapItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: UnitContextMenuClickParams;
}): React.ReactElement {
    const { postMessage: legacyStoreBroadcastPostMessage } = useBroadcast('legacy-store-broadcast');
    const viewLocationOnMap = useViewLocationOnMap();
    const { disableLegacyMapAndSearches, mapWindowEnabled } = useEnabledFeatures();

    return (
        <ContextMenuItem
            dataPendoId="menu-item-view-unit-on-map"
            contextMenuItemView={contextMenuItemView}
            onSelect={() => {
                if (disableLegacyMapAndSearches || mapWindowEnabled) {
                    viewLocationOnMap({
                        entityId: clickParams.unitId,
                        entityType: EsriMapEntityTypeEnum.UNIT,
                    });
                } else {
                    legacyStoreBroadcastPostMessage({
                        type: 'SHOW_UNIT_ON_AVL_MAP',
                        payload: { unitId: clickParams.unitId },
                    });
                }
            }}
        />
    );
}
